import React from 'react'
import './EmailsList.scss'

const EmailsList = ({ emailsList, removeItem }) => {

  const renderEmails = () => {
    return emailsList.map(email => (
      <div className='email-item'>
        <div onClick={() => removeItem(email)}><img src={require('../../../../assets/icons/cross.svg')} alt='cross' /></div>
        <p>{email}</p>
      </div>
    ))
  }

  return (
    <div className='emails-container'>
      {renderEmails()}
    </div>
  )
}

export default EmailsList
